import React, {useState, useEffect} from 'react';
import {  Card, CardBody, Col, } from 'reactstrap';

const Ava = `${process.env.REACT_APP_PUBLIC_URL}usuario/ver-foto/${sessionStorage.getItem('token')}`;

const ProfileMain = () => {

  const user = JSON.parse(sessionStorage.getItem('usuario'));
  const [userData, setUserData] = useState([]);
  const [perfil, setPerfil] = useState([]);

  useEffect(() => {
    getUser(user.usuario);
  }, []);

  const getUser = async (user) => {
    const data = { num_documento: "", nombres: "", apellido1: "", apellido2: "", usuario: user }
    console.log(data);
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'usuario/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log("USERDATA",data.contenido[0]);
        //console.log(data.contenido[0]);
        setUserData(data.contenido[0]);
        getPerfil(data.contenido[0].id_perfil)

      }).catch((error) => {
        console.error('Error:', error);
      });
  }

  const getPerfil = (id) => {
    const data = { id_perfil: id, nombre: "0" }
    console.log(data);
    fetch(process.env.REACT_APP_PUBLIC_URL + 'perfiles/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        setPerfil(data.contenido[0]);

      }).catch((error) => {
        console.error('Error:', error);
      });
  }

  return(
  <Col md={12} lg={12} xl={12}>
    <Card>
      <CardBody className="profile__card">
        <div className="profile__information">
          <div className="profile__avatar">
            <img src={Ava} alt="avatar" />
          </div>
          <div className="profile__data">
            <p className="profile__name">{user.nombre}</p>
            <p className="profile__work">{perfil.nombre}</p>
            <p className="profile__contact">{userData.correo}</p>
            <p className="profile__contact" dir="ltr">{userData.tel_fijo}</p>            
          </div>
        </div>
        
      </CardBody>
    </Card>
  </Col>
);

}

export default ProfileMain;
